/* PMA Reducer */

import { mailProActionConstants, pmaActionConstants } from "../../_constants";
import { tableSortUtil } from "views/Pma/TableSortUtil";
import { renderLogicUtil } from "../../views/Pma/RenderLogicUtil";
import { propertyUtil } from "views/Pma/PropertyUtil";
import { initState } from "./pma.mailpro.state";

export function pmaReducer(state = initState, action) {
  switch (action.type) {
    case pmaActionConstants.IS_LOADING:
      return {
        ...state,
        isLoading: action.payload.status,
      };
    case pmaActionConstants.SWITCH_VERSION:
      return {
        ...state,
        version: action.payload.version,
        hoSearch: "",
        hoFilter: "active",
        hoQuickFilter: "",
        hoAdvanceFilter: "",
        advanceFilterOptionData: "",
        mailProHeader: "homeValuation",
        mailProSortDirection: "desc",
      };

    case pmaActionConstants.UPDATE_MISSION_STATEMENT_MODAL:
      return {
        ...state,
        missionStatementModalOpen: action.payload.isModalOpen,
      };

    case pmaActionConstants.UPDATE_QUADRANT_MODAL:
      //console.log("inside reducer", action.payload);
      return {
        ...state,
        quadrantModalOpen: action.payload.isModalOpen,
      };

    case pmaActionConstants.UPDATE_AGENT_FOCUS_MODAL:
      return {
        ...state,
        agentFocusModalOpen: action.payload.isModalOpen,
      };

    case pmaActionConstants.UPDATE_DESIGN_DETAILS_SPECIFIC_MODAL:
      return {
        ...state,
        designDetailsSpecificModalOpen: action.payload.isModalOpen,
      };

    case pmaActionConstants.UPDATE_CHECKBOX_PHOTO_MODAL:
      return {
        ...state,
        photoCheckboxModalOpen: action.payload.isModalOpen,
      };

    case pmaActionConstants.UPDATE_BACK_PAGE_MODULE:
      return {
        ...state,
        backPageModule: action.payload,
        currentArea: {
          ...(state.currentArea || {}),
          backPageModule: action.payload,
        },
      };

    case pmaActionConstants.UPDATE_DASHBOARD_PAGE_MODULE:
      return {
        ...state,
        currentArea: {
          ...(state.currentArea || {}),
          dashboardPageModule: action.payload,
        },
      };

    case pmaActionConstants.UPDATE_COVER_PHOTO_PREFERENCE:
      return {
        ...state,
        currentArea: {
          ...(state.currentArea || {}),
          coverPhotoPreference: action.payload,
        },
      };

    case pmaActionConstants.UPDATE_KEY_MARKET_AVGS_LIST:
      return {
        ...state,
        keyMarketAvgsList: action.payload ?? null,
      };

    case pmaActionConstants.UPDATE_TP_TRENDS_2_WATCH_LIST:
      return {
        ...state,
        tpTrends2WatchList: action.payload ?? null,
      };

    case pmaActionConstants.UPDATE_DASHBOARD_DETAILS_WITH_PRICE_RANGE: {
      const {
        useCity,
        dashBoardDetailsWithPriceRange,
        priceRangeDashBoardDetailsDTO,
        priceRangeDashBoardDetailsDTOArea,
        priceRangeDashBoardDetailsDTOCity,
      } = action.payload || {};
      const areaDto =
        priceRangeDashBoardDetailsDTOArea ??
        (!useCity ? priceRangeDashBoardDetailsDTO : null);
      const cityDto =
        priceRangeDashBoardDetailsDTOCity ??
        (useCity ? priceRangeDashBoardDetailsDTO : null);
      const hasValidAreaDto =
        areaDto &&
        Array.isArray(areaDto.priceRangeListArea) &&
        areaDto.priceRangeListArea.length > 0;
      const hasValidCityDto =
        cityDto &&
        Array.isArray(cityDto.priceRangeListCity) &&
        cityDto.priceRangeListCity.length > 0;
      const nextState = {
        ...state,
        ...(hasValidAreaDto
          ? { priceRangeDashBoardDetailsDTOArea: areaDto }
          : {}),
        ...(hasValidCityDto
          ? { priceRangeDashBoardDetailsDTOCity: cityDto }
          : {}),
      };
      if (useCity) {
        return {
          ...nextState,
          quarterlyCityTable: {
            ...state.quarterlyCityTable,
            ...(dashBoardDetailsWithPriceRange
              ? { dashBoardDetailsWithPriceRange }
              : {}),
          },
          MQCityDetails: {
            ...state.MQCityDetails,
            ...(dashBoardDetailsWithPriceRange
              ? { dashBoardDetailsWithPriceRange }
              : {}),
          },
        };
      }
      return {
        ...nextState,
        quarterlyAreaTable: {
          ...state.quarterlyAreaTable,
          ...(dashBoardDetailsWithPriceRange
            ? { dashBoardDetailsWithPriceRange }
            : {}),
        },
      };
    }

    case pmaActionConstants.UPDATE_TP_LOGOS_REQUEST:
      return {
        ...state,
        updateTPLogosStatus: "loading",
        updateTPLogosError: null,
      };

    case pmaActionConstants.UPDATE_TP_LOGOS_SUCCESS:
      return {
        ...state,
        updateTPLogosStatus: "success",
        updateTPLogosResponse: action.payload,
        updateTPLogosError: null,
      };

    case pmaActionConstants.UPDATE_TP_LOGOS_FAILURE:
      return {
        ...state,
        updateTPLogosStatus: "failure",
        updateTPLogosError: action.payload,
      };

    case pmaActionConstants.SWITCH_STEP:
      return {
        ...state,
        isLoading: false,
        currentStep: action.payload.step,
      };
    case pmaActionConstants.SWITCH_AREA:
      return {
        ...state,
        hoSearch: "",
        hoFilter: "active",
        hoQuickFilter: "",
        hoAdvanceFilter: "",
        advanceFilterOptionData: "",
        mailProHeader: "homeValuation",
        mailProSortDirection: "desc",
        isLoading: action.payload.isLoading,
        currentArea: action.payload.area,
        // Don't reset propertyData to prevent data loss
        // propertyData: [],
        singleHOData: [],
        pmaMailerDataLoaded: false,
        currentAreaFirstMailProID: 0,
      };
    case pmaActionConstants.SWITCH_AREA_WITH_STEP:
      return {
        ...state,
        hoSearch: "",
        hoFilter: "active",
        hoQuickFilter: "",
        hoAdvanceFilter: "",
        advanceFilterOptionData: "",
        mailProHeader: "homeValuation",
        mailProSortDirection: "desc",
        isLoading: true,
        currentArea: action.payload.area,
        currentStep: action.payload.step,
        propertyData: [],
        singleHOData: [],
        pmaMailerDataLoaded: false,
        currentAreaFirstMailProID: 0,
      };

    case pmaActionConstants.UPDATE_CURRENT_AREA_DATA:
      return {
        ...state,
        currentArea: action.payload,
      };
    case pmaActionConstants.UPDATE_IS_PROPERTY_HIGHLIGHTS:
      let updatedCurrentArea = {
        ...state.currentArea,
        isPropertyHighlights: action.payload,
      };

      return {
        ...state,
        currentArea: updatedCurrentArea,
      };

    case pmaActionConstants.SWITCH_CL_VERSION:
      const { version } = action.payload;
      return {
        ...state,
        viewingGeneratedCL: version,
      };
    case pmaActionConstants.RESET_MAILPRO_HEADER_AND_ALL_FILTERS:
      return {
        ...state,
        hoSearch: "",
        hoFilter: "active", //show active props only by default
        hoQuickFilter: "",
        hoAdvanceFilter: "",
        advanceFilterOptionData: "",
        mailProHeader: "", // have to reset mailpro header inc ase of any operation except first load/area change
        mailProSortDirection: "desc",
      };
    case pmaActionConstants.SET_CURRENT_RECORD:
      return {
        ...state,
        currentRecord: action.payload.record,
      };
    case pmaActionConstants.SET_BLOCKED_REASON:
      return {
        ...state,
        blockedReason: action.payload.reason,
      };
    case pmaActionConstants.SET_TAGS:
      return {
        ...state,
      };
    case pmaActionConstants.UPDATE_HO_SEARCH:
      return {
        ...state,
        hoSearch: action.payload.searchTerm,
        //we dont have to reset the mailpro as in this case we are doing to perform search on already sorted data
        // mailProHeader: "",// have to reset mailpro header inc ase of any operation except first load/area change
        // mailProSortDirection: "desc",
      };
    case pmaActionConstants.UPDATE_HO_FILTER:
      return {
        ...state,
        hoFilter: action.payload.filterStatus,
        mailProHeader: "", // have to reset mailpro header inc ase of any operation except first load/area change
        mailProSortDirection: "desc",
      };
    case pmaActionConstants.UPDATE_HO_QUICK_FILTER:
      return {
        ...state,
        hoQuickFilter: action.payload.quickFilter,
        mailProHeader: action.payload.quickFilter ? "lastSaleDate" : "",
        mailProSortDirection: action.payload.quickFilter ? "desc" : "",
      };
    case pmaActionConstants.UPDATE_HO_ADVANCE_FILTER:
      return {
        ...state,
        hoAdvanceFilter: action.payload.advanceFilter,
        mailProHeader: "",
        mailProSortDirection: "",
      };
    case pmaActionConstants.UPDATE_HO_ADVANCE_FILTER_OPTION_DATA:
      return {
        ...state,
        advanceFilterOptionData: action.payload.advanceFilterOptionData,
        //mailProHeader: "",
        //mailProSortDirection: "",
      };
    case pmaActionConstants.RESET_MAILPRO_HEADER_SORT_ONLY:
      return {
        ...state,
        mailProHeader: "", // have to reset mailpro header inc ase of any operation except first load/area change
        mailProSortDirection: "desc",
      };
    case pmaActionConstants.TABLE_SORT:
      return {
        ...state,
        propertyData: action.payload.propertyData,
        mailProHeader: action.payload.mailProHeader,
        mailProSortDirection: action.payload.mailProSortDirection,
        isLoading: false,
      };

    case pmaActionConstants.POST_HOMEOWNERS_DATA:
      return { ...state };

    case pmaActionConstants.GET_MAILER_PRO_DETAILS_SUCCESS:
      const lastPMAPrintDate = propertyUtil.getLastPrintDate();
      const nextPMAPrintDate =
        action.payload.nextPMAPrintDate || state.nextPMAPrintDate;
      let propertyData = action.payload.propertyData;

      propertyData = renderLogicUtil.getQuickFilterData(
        propertyData,
        nextPMAPrintDate,
        lastPMAPrintDate,
        action.payload.agentData,
      );

      // If getQuickFilterData returned empty due to a bad API response (e.g.
      // JSON string instead of array), keep the existing state rather than
      // blanking the table for the agent.
      if (!propertyData || propertyData.length === 0) {
        return { ...state, isLoading: false };
      }

      let finalData = action.payload.defaultSort
        ? tableSortUtil.hoValuationSorting(
            propertyData,
            action.payload.agentData,
            false,
          )
        : propertyData;

      return {
        ...state,
        propertyData: finalData, //add data by default sorted by homeValuation in desc order
        currentAreaFirstMailProID: (finalData.find(
          (property) =>
            property.mailerProID !== "" && property.mailerProID !== null,
        ) || {}).mailerProID, //this will tell that new area data is loaded.
        isLoading: false,
        pmaMailerDataLoaded: action.payload.pmaMailerDataLoaded,
      };

    case pmaActionConstants.GET_MAILER_PRO_DETAILS_FAILURE:
      return {
        ...state,
        propertyData: action.payload.propertyData,
        pmaMailerDataLoaded: action.payload.pmaMailerDataLoaded,
        isLoading: false,
      };

    case pmaActionConstants.UPDATE_HOMEOWNER_PROP:
      const { mailerProID, changeDetails, hoData, mailingDetails } =
        action.payload;

      let index = state.propertyData
        .map((e) => e.mailerProID)
        .indexOf(mailerProID);

      const actualHO = state.propertyData[index];
      actualHO.changeDetails = actualHO.changeDetails
        ? { ...actualHO.changeDetails, ...changeDetails }
        : changeDetails;
      actualHO.mailingDetails = actualHO.mailingDetails
        ? { ...actualHO.mailingDetails, ...mailingDetails }
        : mailingDetails;
      state.propertyData[index] = { ...actualHO, ...hoData };
      return {
        ...state,
        propertyData: [...state.propertyData],
      };
    case pmaActionConstants.UPDATE_RECENT_UPDATED_MAILPRO_ID:
      return {
        ...state,
        recentlyUpdatedMailProID: action.payload,
      };
    case pmaActionConstants.GET_CITY_AREA_MAP:
      return {
        ...state,
      };
    case pmaActionConstants.GET_MAILPRO_ID_DETAILS:
      return {
        ...state,
        getSingleHOData: action.payload,
      };
    case pmaActionConstants.GET_MAILPRO_STATUS:
      return {
        ...state,
      };
    case pmaActionConstants.GET_MARKET_ACTIVITY:
      if (action.payload.clear) {
        return {
          ...state,
          marketActivity: action.payload,
          // quarterlyAreaTable: [],
          // quarterlyCityTable: [],
        };
      } else {
        return {
          ...state,
          marketActivity: action.payload,
        };
      }

    case pmaActionConstants.GET_NAVBAR_INFO:
      const modifiedDetails = renderLogicUtil.buildNavbarDataForMailPro(
        action.payload,
      );
      return {
        ...state,
        mlsAreas: modifiedDetails,
      };

    case pmaActionConstants.UPDATE_NAVBAR:
      let areaData = action.payload;
      //we call same action in case of approaval of mailing list so we have to check if its array or not. if its array no need to convert it because it already an area data
      if (!Array.isArray(areaData)) {
        areaData = renderLogicUtil.buildNavbarDataForMailPro(action.payload);
      }
      return {
        ...state,
        mlsAreas: areaData,
      };

    case pmaActionConstants.GET_MQ_CITY_DETAILS:
      // console.log('reducer getting total units', action.payload);
      return {
        ...state,
        MQCityDetails: action.payload,
      };
    case pmaActionConstants.GET_DATA_VERIFICATION:
      return {
        ...state,
        dataVerification: action.payload,
      };

    case pmaActionConstants.GET_APRIL_API:
      // console.log("reducer getting april API", action.payload);
      return {
        ...state,
        aprilData: action.payload,
        // MQCityDetails: null,
        // agentAdvantages: null,
        // agentDesignations: null,
        // marketActivity: null,
        // qAreaAndCityDetails: null,
        // testimonials: null,
        // yearEnd: null
      };
    case pmaActionConstants.GET_MAY_API:
      //  console.log("reducer getting MAY API", action.payload);
      const {
        quarterlyAreaTable,
        MQCityDetails,
        agentDesignations,
        coverPageDetails,
        // testimonials
      } = action.payload;

      return {
        ...state,
        quarterlyAreaTable,
        MQCityDetails,
        agentDesignations,
        testimonials: action.payload.testimonials,
        coverPageDetails,
      };

    case pmaActionConstants.UPDATE_RECENT_ACTIVITY_DATA:
      return {
        ...state,
        recentActivityPhotoList: action.payload,
      };

    case pmaActionConstants.GET_RECENT_ACTIVITY_PHOTOS:
      // console.log("reducer getting GET_RECENT_ACTIVITY_PHOTOS", action.payload);

      return {
        ...state,
        recentActivityPhotoList: action.payload,
        oldRecentActivityPhotoList: action.payload,
      };

    case pmaActionConstants.GET_TABLE_PMA_API:
      //console.log("reducer getting TABLE PMA API", action.payload);

      return {
        ...state,
        quarterlyAreaTable: action.payload.quarterlyAreaTable,
        MQCityDetails: action.payload.MQCityDetails,
        testimonials: action.payload.testimonials,
        coverPageDetails: action.payload.coverPageDetails,
      };
    case pmaActionConstants.GET_DONUT_AND_TABLE:
      //console.log("action.payload is", action.payload);
      return {
        ...state,
        singleHOData: action.payload.mailerPrintInfoDTO.mailerProDTO,
        agentData: action.payload.mailerPrintInfoDTO.listgenUserDTO,
        // currentArea,
        coverPageDetails: action.payload.pmaCoverPhotoDTO,
        quarterlyAreaTable: action.payload.pmaQuarterlyAreaDTO,
        quarterlyCityTable: action.payload.pmaQuarterlyCityDTO,

        MQCityDetails: action.payload.pmaQuarterlyCityDTO,
        testimonials: action.payload.mailerPrintInfoDTO.lgTestimonialsDTO,
        missionStatement: action.payload.missionStatementDTO,
        pmaQuarterlyCombinedCityDTO: action.payload.pmaQuarterlyCombinedCityDTO,
        quadrantDetails: action.payload.quadrantInfoList,
        agentFocusInfoList: action.payload.agentFocusInfoList,
        designDetailsInfoList: action.payload.designDetailsInfoList,
        tpTrends2WatchList: action.payload.tpTrends2WatchList ?? null,
        volunteerDetails: action.payload.bpciList,
        localEventsDetails: action.payload.bpciList,
        propertyPhotoDetailsDTO: action.payload.propertyPhotoDetailsDTO,
      };
    case pmaActionConstants.GET_DASHBOARD_DONUT_API:
      return {
        ...state,
        coverPageDetails: action.payload.pmaCoverPhotoDTO,
        aprilData: {
          pmaQuarterlyAreaDTO: action.payload.pmaQuarterlyAreaDTO,
          pmaQuarterlyCityDTO: action.payload.pmaQuarterlyCityDTO,
        },
      };

    case pmaActionConstants.GET_PMA_DETAILS_API: {
      const payload = action.payload || {};
      const pmaQuarterlyAreaDTO = payload.pmaQuarterlyAreaDTO;
      const mailerPrintInfoDTO = payload.mailerPrintInfoDTO || {};
      const navbarInfoList = payload.navbarInfoList || [];
      const thisAreaID = pmaQuarterlyAreaDTO?.areaID;

      const thisArea = thisAreaID
        ? navbarInfoList.find((area) => area.mlsAreaID === thisAreaID)
        : undefined;

      const dashboardValuationFiltered =
        thisAreaID && payload.dbpageFooterList
          ? payload.dbpageFooterList.find(
              (valuation) => valuation.dbpfareaID === thisAreaID,
            )
          : null;

      return {
        ...state,
        currentArea: thisArea || state.currentArea,
        testimonials:
          mailerPrintInfoDTO.lgTestimonialsDTO ?? state.testimonials,
        singleHOData: mailerPrintInfoDTO.mailerProDTO ?? state.singleHOData,
        agentData: mailerPrintInfoDTO.listgenUserDTO ?? state.agentData,
        altAgentData: mailerPrintInfoDTO.listgenUserDTO ?? state.altAgentData,
        dashboardValuation:
          dashboardValuationFiltered ?? state.dashboardValuation,
        coverPageDetails: payload.pmaCoverPhotoDTO ?? state.coverPageDetails,
        quarterlyAreaTable: pmaQuarterlyAreaDTO ?? state.quarterlyAreaTable,
        quarterlyCityTable:
          payload.pmaQuarterlyCityDTO ?? state.quarterlyCityTable,
        MQCityDetails: payload.pmaQuarterlyCityDTO ?? state.MQCityDetails,
        quadrantDetails: payload.quadrantInfoList ?? state.quadrantDetails,
        agentFocusInfoList:
          payload.agentFocusInfoList ?? state.agentFocusInfoList,
        designDetailsInfoList:
          payload.designDetailsInfoList ?? state.designDetailsInfoList,
        tpTrends2WatchList:
          payload.tpTrends2WatchList ?? state.tpTrends2WatchList ?? null,
        volunteerDetails: payload.bpciList ?? state.volunteerDetails,
        localEventsDetails: payload.bpciList ?? state.localEventsDetails,
        bubbleBoxes: payload.marketValueInfoList ?? state.bubbleBoxes,
        propertyPhotoDetailsDTO:
          payload.propertyPhotoDetailsDTO ?? state.propertyPhotoDetailsDTO,
        aprilData: {
          pmaQuarterlyCityDTO:
            payload.pmaQuarterlyCityDTO ?? state.aprilData?.pmaQuarterlyCityDTO,
          pmaQuarterlyAreaDTO:
            pmaQuarterlyAreaDTO ?? state.aprilData?.pmaQuarterlyAreaDTO,
        },
        missionStatement: payload.missionStatementDTO ?? state.missionStatement,
        miniTableDetailsDTO:
          payload.miniTableDetailsDTO ?? state.miniTableDetailsDTO,
        priceRangeDashBoardDetailsDTOArea:
          payload.priceRangeDashBoardDetailsDTOArea ??
          state.priceRangeDashBoardDetailsDTOArea,
        priceRangeDashBoardDetailsDTOCity:
          payload.priceRangeDashBoardDetailsDTOCity ??
          state.priceRangeDashBoardDetailsDTOCity,
        keyMarketAvgsList:
          payload.keyMarketAvgsList ?? state.keyMarketAvgsList ?? null,
      };
    }

    case pmaActionConstants.GET_MARKET_TRENDS_API:
      const { pmaQuarterlyCityDTO, pmaQuarterlyAreaDTO } =
        action.payload.resData;

      return {
        ...state,
        coverPageDetails: action.payload.resData.pmaCoverPhotoDTO,
        aprilData: { pmaQuarterlyCityDTO, pmaQuarterlyAreaDTO },
        pmaQuarterlyCombinedCityDTO:
          action.payload.resData.pmaQuarterlyCombinedCityDTO,
        quadrantDetails: action.payload.resData.quadrantInfoList,
        agentFocusInfoList: action.payload.resData.agentFocusInfoList,
        designDetailsInfoList: action.payload.resData.designDetailsInfoList,
        tpTrends2WatchList: action.payload.resData.tpTrends2WatchList ?? null,
        oldPhotoDetails: JSON.parse(
          JSON.stringify(
            action.payload.resData.pmaQuarterlyAreaDTO.currentSoldListings,
          ),
        ),
        singleHOData: action.payload.singleHOData,
        propertyPhotoDetailsDTO: action.payload.resData.propertyPhotoDetailsDTO,
        testimonials:
          action.payload.resData.mailerPrintInfoDTO.lgTestimonialsDTO,
      };

    case pmaActionConstants.GET_AGENT_QR:
      return {
        ...state,
        qrCodeMailerProID: action.payload,
      };

    case pmaActionConstants.GET_PROPERTY_PHOTO_DETAILS:
      return {
        ...state,
        photoTableData: action.payload.resData.photoDetails,
      };

    case pmaActionConstants.GET_TABLE_BUBBLE_DATA:
      return {
        ...state,
        testimonials: action.payload.testimonials,
        coverPageDetails: action.payload.coverPageDetails,
        quarterlyCityTable: action.payload.quarterlyCityTable,
        quarterlyAreaTable: action.payload.quarterlyAreaTable,
      };

    case pmaActionConstants.GET_BUBBLE_PRICE_RANGE:
      return {
        ...state,
        testimonials: action.payload.lgTestmonialsDTO,
        coverPageDetails: action.payload.pmaCoverPhotoDTO,
        quarterlyCityTable: action.payload.pmaQuarterlyCityDTO,
        quarterlyAreaTable: action.payload.pmaQuarterlyAreaDTO,
        singleHOData: action.payload.mailerPrintInfoDTO.mailerProDTO,
        bubbleBoxes: action.payload.marketValueInfoList,
      };

    case pmaActionConstants.GET_SPEEDOMETER_DATA:
      return {
        ...state,
        coverPageDetails: action.payload.coverPageDetails,
        quarterlyAreaTable: action.payload.quarterlyAreaTable,
        quarterlyCityTable: action.payload.quarterlyCityTable,
        singleHOData: action.payload.singleHOData,
        testimonials: action.payload.testimonials,
      };

    case pmaActionConstants.GET_BUBBLE_BOX_DETAILS:
      return {
        ...state,
        bubbleBoxes: action.payload.bubbleBoxDetails,
      };

    case pmaActionConstants.GET_QUADRANT_DETAILS:
      return {
        ...state,
        quadrantDetails: action.payload.quadrantDetails,
      };

    case pmaActionConstants.GET_AGENT_FOCUS_INFO_LIST:
      return {
        ...state,
        agentFocusInfoList: action.payload.agentFocusInfoList,
      };

    case pmaActionConstants.GET_DESIGN_DETAILS_INFO_LIST:
      return {
        ...state,
        designDetailsInfoList: action.payload.designDetailsInfoList,
      };

    case pmaActionConstants.GET_VOLUNTEER_LIST:
      return {
        ...state,
        volunteerList: action.payload,
      };

    case pmaActionConstants.GET_LOCAL_EVENTS_LIST:
      return {
        ...state,
        localEventsList: action.payload,
      };

    case pmaActionConstants.GET_DECEMBER_DATA:
      return {
        ...state,
        coverPageDetails: action.payload.coverPageDetails,
        aprilData: {
          pmaAprilCityDTO: action.payload.quarterlyCityTable,
          pmaAprilRunAreaDTO: action.payload.quarterlyAreaTable,
        },
        propertyPhotoDetailsDTO: action.payload.propertyPhotoDetailsDTO,
        testimonials: action.payload.testimonials,
        quarterlyAreaTable: action.payload.quarterlyAreaTable,
        quarterlyCityTable: action.payload.quarterlyCityTable,
        singleHOData: action.payload.singleHOData,
        // agentData: action.payload.agentData,
        pmaQuarterlyCombinedCityDTO: action.payload.pmaQuarterlyCombinedCityDTO,
        quadrantDetails: action.payload.quadrantInfoList,
        agentFocusInfoList: action.payload.agentFocusInfoList,
        designDetailsInfoList: action.payload.designDetailsInfoList,
        tpTrends2WatchList: action.payload.tpTrends2WatchList ?? null,
      };
    case pmaActionConstants.GET_MQ2_CITY_DETAILS:
      const { testimonials, pmaMidQuarterlyAreaDTO } = action.payload;
      return {
        ...state,
        testimonials,
        MQCityDetails: pmaMidQuarterlyAreaDTO,
      };

    case pmaActionConstants.GET_LOCAL_SELLING_AGENTS:
      return {
        ...state,
        localSellingAgents: action.payload,
      };

    case pmaActionConstants.GET_QUARTER_AREA_TABLE:
      if (action.payload.clear) {
        return {
          ...state,
          quarterlyAreaTable: action.payload,
        };
      } else {
        return {
          ...state,
          quarterlyAreaTable: action.payload,
        };
      }

    case pmaActionConstants.GET_QUARTER_CITY_TABLE:
      return {
        ...state,
        quarterlyCityTable: action.payload,
      };

    case pmaActionConstants.GET_MISSION_STATEMENT:
      return {
        ...state,
        missionStatement: action.payload,
      };

    case pmaActionConstants.GET_PMA_COVER_PHOTO_DETAILS:
      return {
        ...state,
        coverPageDetails: action.payload,
      };
    case pmaActionConstants.GET_YEAR_END_DETAILS:
      return {
        ...state,
        yearEnd: action.payload,
      };

    case pmaActionConstants.GET_SAT:
      const {
        lgTestimonialsDTO,
        listAgentAdvantagesDTO,
        listAgentDesignationsDTO,
      } = action.payload;

      return {
        ...state,
        testimonials: lgTestimonialsDTO ? lgTestimonialsDTO : "none",
        agentAdvantages: listAgentAdvantagesDTO
          ? listAgentAdvantagesDTO
          : "none",
        agentDesignations: listAgentDesignationsDTO
          ? listAgentDesignationsDTO
          : "none",
      };

    case pmaActionConstants.GET_SALE_PRICE_FOR_CITIES:
      return {
        ...state,
        salePriceForCities: action.payload ? action.payload : "none",
      };

    case pmaActionConstants.GET_AGENT_DESIGNATIONS:
      return {
        ...state,
        agentDesignations: action.payload,
      };
    case pmaActionConstants.CHANGE_PDF_PRINT_VERSION:
      return {
        ...state,
        pdfPrintVersion: action.payload,
      };

    case pmaActionConstants.GET_AGENT_ADVANTAGES:
      return {
        ...state,
        agentAdvantages: action.payload,
      };

    case pmaActionConstants.GET_TESTIMONIALS:
      return {
        ...state,
        testimonials: action.payload,
      };

    //MailPro Related Reducers

    case pmaActionConstants.GET_NEXT_PMA_PRINT_DATE:
      return {
        ...state,
        nextPMAPrintDate: action.payload,
      };

    case pmaActionConstants.NEW_MAILING_ADD_UPDATED_DATA:
      let currentNewMMailingEditedData = state.newMailingEditedData;
      if (action.payload.resetMode) {
        currentNewMMailingEditedData = [];
      } else if (action.payload.isPropertyAlreadyEdited) {
        //if current property is already updated update at old index
        currentNewMMailingEditedData = currentNewMMailingEditedData.map(
          (item) => {
            if (item.mailerProID === action.payload.mailerProID) {
              return action.payload;
            }
            return item;
          },
        );
      } else {
        currentNewMMailingEditedData.push(action.payload);
      }

      return {
        ...state,
        newMailingEditedData: [...currentNewMMailingEditedData],
      };

    case pmaActionConstants.SET_NEW_MAILPRO_INIT_DIALOG_MODE:
      return {
        ...state,
        newMailProInitDialogMode: action.payload,
      };

    case pmaActionConstants.DISABLE_NEW_MAILING_FOR_CURRENT_SESSION:
      return {
        ...state,
        disableNewMailingForCurrentSession: action.payload,
      };

    case pmaActionConstants.EXPLICIT_ENABLE_NEW_MAILPRO_INIT_SCREEN:
      return {
        ...state,
        explicitEnableNewMailProInit: action.payload,
      };

    case pmaActionConstants.NEW_MAILING_MAILPRO_DATA:
      return {
        ...state,
        newMailingMailProData: action.payload,
      };

    case pmaActionConstants.RESET_NEW_MAILPRO_INIT_DIALOG_DATA:
      return {
        ...state,
        explicitEnableNewMailProInit: false,
        disableNewMailingForCurrentSession: false,
        newMailProInitDialogMode: null,
        newMailingMailProData: [],
        newMailingEditedData: [],
      };

    case mailProActionConstants.APPROVE_MAILPRO_AREA:
      if (action.payload.isApproved) {
        return {
          ...state,
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
